import { render, staticRenderFns } from "./read-only-dialog.vue?vue&type=template&id=de7b1974&"
import script from "./read-only-dialog.vue?vue&type=script&lang=js&"
export * from "./read-only-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports